export class Inbound {
  constructor({
    inboundID = 0,
    orderID = 0,
    contractLengthMonths = 0,
    typeOfNumber = null,
    serviceNumber = null,
    erouNumber = null,
    accountNumber = null,
    serviceProvider = null,
    routing = null,
    answeringPoint = null,
    ratePlanId = 0,
    stateBased = [],
  } = {}) {
    this.inboundID = inboundID;
    this.orderID = orderID;
    this.contractLengthMonths = contractLengthMonths;
    this.typeOfNumber = typeOfNumber;
    this.serviceNumber = serviceNumber;
    this.erouNumber = erouNumber;
    this.accountNumber = accountNumber;
    this.routing = routing;
    this.answeringPoint = answeringPoint;
    this.ratePlanId = ratePlanId;
    this.stateBased = stateBased;
    this.serviceProvider = serviceProvider;
  }
}

export function CreateNewInbound(data) {
  return Object.freeze(new Inbound(data));
}
